import { useState, useEffect } from 'react'

const QUERY = '(max-width: 767px)'

/**
 * True when the CSS viewport is phone-narrow.
 * Width-only (not UA sniffing) so narrow desktop windows get the same shell.
 */
export function useIsPhone() {
  const [isPhone, setIsPhone] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false
    return window.matchMedia(QUERY).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined
    const mql = window.matchMedia(QUERY)
    const onChange = () => setIsPhone(mql.matches)
    onChange()
    if (mql.addEventListener) mql.addEventListener('change', onChange)
    else mql.addListener(onChange)
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange)
      else mql.removeListener(onChange)
    }
  }, [])

  return isPhone
}
